<template>
	<div class="c-coupon flex" :class="{'z-crt': current, 'z-dis': disabled, 'z-receive': received, 'z-used': used}" @click="clickHandle">
		<div class="c-coupon-main flex-column flex-center">
			<div class="sum tf-num">￥<strong>{{data.decrease_amount}}</strong></div>
			<div class="limit">{{data.coupon_condition_str || data.coupon_condition}}</div>
		</div>
		<div class="c-coupon-info flex-grow flex-column flex-center-main">
			<div class="range ellipsis">{{data.commodity_range || data.commodity_remark}}</div>
			<div class="date">{{data.valid_date_str || data.valid_date}}</div>
			<div v-if="disabled && data.not_can_reason" class="date" style="color: #f55;">{{data.not_can_reason}}</div>
		</div>
		<i class="check tf tf-check"></i>
	</div>
</template>

<script>
	export default {
		props: {
			data: Object,
			current: Boolean,
			received: Boolean,
			disabled: Boolean,
			used: Boolean
		},
		
		methods: {
			clickHandle() {
				!this.disabled && this.$emit('click', this.data);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-coupon {
		box-sizing: border-box;
		position: relative;
		width: 300px;
		height: 98px;
		background-repeat: no-repeat;
		background-position: right 8px center;
		background-size: 60px auto;
		cursor: pointer;
		
		&.z-crt {
			&:after {
				content: '';
				position: absolute;
				right: -20px;
				top: -20px;
				border-top: 20px solid #FFC600;
				border-left: 20px solid rgba(0,0,0,0);
				border-right: 20px solid rgba(0,0,0,0);
				transform: rotate(-135deg);
				transform-origin: center bottom;
			}
			
			.check {
				display: block;
			}
		}
		
		&.z-receive {
			background-image: url('~@/assets/image/coupon/z_receive.png');
		}
		
		&.z-dis {
			// background-image: url('~@/assets/image/coupon/z_disabled.png');
			
			.c-coupon-main {
				background-image: url('~@/assets/image/coupon/main_dis.png');
			}
		}
		
		&.z-used {
			background-image: url('~@/assets/image/coupon/z_used.png');
		}
		
		&-main {
			gap: 4px;
			position: relative;
			width: 115px;
			text-align: center;
			background-image: url('~@/assets/image/coupon/main.png');
			background-size: 100% 100%;
			
			.sum {
				font-size: 20px;
				font-weight: bold;
				color: #000;
				
				strong {
					font-size: 32px;
					font-weight: normal;
				}
			}
			
			.limit {
				font-size: 13px;
				color: #000;
			}
		}
		
		&-info {
			gap: 8px;
			border: 1px solid #eee;
			padding: 0 14px;
			
			.range {
				font-size: 15px;
				color: #333;
			}
			
			.date {
				font-size: 12px;
				color: #999;
			}
		}
		
		.check {
			display: none;
			z-index: 1;
			position: absolute;
			right: 1px;
			top: 1px;
			font-size: 14px;
			color: #fff;
		}
	}
</style>
